import React from "react";

const NotShoutableInSpace = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.02976 14.2617C11.9759 14.2617 14.3642 11.8734 14.3642 8.92722C14.3642 5.98109 11.9759 3.59277 9.02976 3.59277C6.08363 3.59277 3.69531 5.98109 3.69531 8.92722C3.69531 11.8734 6.08363 14.2617 9.02976 14.2617Z"
        stroke="black"
      />
      <path
        d="M14.2207 15.2713C18.0654 11.3065 18.0654 6.02014 14.2207 2.58398"
        stroke="black"
      />
      <path
        d="M3.83856 2.58496C-0.00608373 6.54976 -0.00608373 11.8361 3.83856 15.2723"
        stroke="black"
      />
      <path
        d="M9.06704 8.65716C9.22024 8.65716 9.35378 8.63853 9.46765 8.60126C9.58153 8.56193 9.67573 8.50706 9.75026 8.43667C9.82687 8.3642 9.8838 8.27725 9.92107 8.1758C9.95833 8.07228 9.97697 7.95737 9.97697 7.83108C9.97697 7.711 9.95833 7.6023 9.92107 7.505C9.8838 7.40769 9.8279 7.32487 9.75337 7.25655C9.67883 7.18823 9.58463 7.13647 9.47076 7.10127C9.35689 7.06401 9.22231 7.04537 9.06704 7.04537H8.44282V8.65716H9.06704ZM9.06704 6.39941C9.36724 6.39941 9.62707 6.43461 9.84653 6.505C10.066 6.5754 10.2471 6.67374 10.39 6.80003C10.5329 6.92633 10.6384 7.07746 10.7068 7.25345C10.7772 7.42943 10.8124 7.62197 10.8124 7.83108C10.8124 8.04847 10.7761 8.24826 10.7037 8.43046C10.6312 8.61058 10.5225 8.76586 10.3776 8.89629C10.2326 9.02673 10.0505 9.12817 9.83101 9.20064C9.61362 9.2731 9.35896 9.30933 9.06704 9.30933H8.44282V10.89H7.60742V6.39941H9.06704Z"
        fill="black"
      />
      <path
        d="M15.8136 13.2555L3.98047 2.45215L2.76277 3.78592L14.5959 14.5892L15.8136 13.2555Z"
        fill="black"
      />
    </svg>
  );
};

export default NotShoutableInSpace;
